import apiClient from './apiClient';

export const getActiveAnnouncements = async () => {
  const response = await apiClient.get('/api/announcements/active');
  return response.data;
};

export const getAllAnnouncements = async () => {
  const response = await apiClient.get('/api/announcements');
  return response.data;
};

export const getAnnouncementById = async (id) => {
  const response = await apiClient.get(`/api/announcements/${id}`);
  return response.data;
};

export const createAnnouncement = async (data) => {
  const response = await apiClient.post('/api/announcements', data);
  return response.data;
};

export const updateAnnouncement = async (id, data) => {
  const response = await apiClient.put(`/api/announcements/${id}`, data);
  return response.data;
};

export const deleteAnnouncement = async (id) => {
  const response = await apiClient.delete(`/api/announcements/${id}`);
  return response.data;
};

// Push an announcement to users' notification bells (+ email digest for
// opted-in users). audience: 'ALL' | 'AUTHORS' | 'AUTHOR_PROFILES' | 'READERS'.
export const broadcastAnnouncement = async ({ title, message, audience, linkUrl }) => {
  const response = await apiClient.post('/api/announcements/broadcast', {
    title, message, audience, linkUrl,
  });
  return response.data;
};
